import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionBenefit/SectionBenefit.module.scss';

const cn = classNames.bind(styles);

const SectionBenefit = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderHeadingContentByScreenWidth = () => {
    if (screenWidth >= 769) {
      return (
        <>
          <span>How a DFA Membership can mimimise</span>{' '}
          <span>Demurrage & Detention Charges</span>
        </>
      );
    } else {
      return (
        <>
          <span>How a DFA Membership can</span>{' '}
          <span>mimimise Demurrage &</span>{' '}
          <span>Detention Charges</span>
        </>
      );
    }
  };

  return (
    <section className={cn('benefit')}>
      <div className={cn('container')}>

        <h2 className={cn('benefit__heading')}>
          {renderHeadingContentByScreenWidth()}
        </h2>

        <div className={cn('benefit__description')}>
          <div className={cn('benefit__description-container')}>
            <p className={cn('benefit__description-paragraph')}>
              As a logistics Member of Digital Freight Alliance, with access to Container Tracking, Ship
              Schedules and Logistics Explorer, businesses can utilise industry-leading
              digital tools to mitigate the risk of freight charges.
            </p>
          </div>
          <div className={cn('benefit__description-container')}>
            <p className={cn('benefit__description-paragraph')}>
              Offering automated notifications and alerts, our solution informs users about critical events
              and deadlines such as container arrival and pick-up, and the expiration of free time periods for
              container storage, thereby reducing the risk of incurring demurrage and detention charges. By
              taking timely action when a container arrives, users can avoid detention and demurrage fees
              that would otherwise need to be paid by the shipper or consignee. All events and milestones
              for multiple carriers and containers can be viewed in the Demurrage and Detention dashboard
              for convenience. Enhanced coordination and communication among all stakeholders in the
              supply chain ensures timely decisions and streamlined operations, minimising the chances of
              containers being held up at ports or terminals.
            </p>
          </div>
        </div>

        <div className={cn('benefit__image-container')}>
          <picture>
            <source
              srcSet="
                /images/pages/Resources/DemurrageAndDetention/calculator.webp 1x,
                /images/pages/Resources/DemurrageAndDetention/calculator@2x.webp 2x
              "
              sizes="100vw"
            />
            <img
              className={cn('benefit__image')}
              src="/images/pages/Resources/DemurrageAndDetention/calculator.webp"
              alt="Demurrage and Storage Calculator"
            />
          </picture>
        </div>

        <div className={cn('benefit__description')}>
          <div className={cn('benefit__description-container')}>
            <p className={cn('benefit__description-paragraph')}>
              CARGOES Flow also leverages advanced data analytics and high-fidelity data, to provide
              valuable, accurate insights into supply chain operations, helping users identify bottlenecks and
              optimise routes and schedules for efficient resource use and timely container delivery.
            </p>
          </div>
          <div className={cn('benefit__description-container')}>
            <p className={cn('benefit__description-paragraph')}>
              Its robust document management capabilities allow users to handle all necessary shipping
              documents digitally, expediting customs clearance and maintaining accurate records to
              support dispute resolution.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionBenefit;